/**
 * Bare http(s) URLs in plain text, as members' clients linkify DV-311 TEXT bodies. Shared by the
 * TEXT preview (complianceMessages) and the TEXT-to-HTML conversion (complianceHtml).
 */

// Bare http(s) URLs. Trailing punctuation is trimmed below so "see https://x.com." links x.com.
const URL_PATTERN = /https?:\/\/[^\s<>"]+/g;
const TRAILING_PUNCTUATION = /[.,;:!?'")\]}]+$/;

/**
 * Splits plain text into text and URL segments, the way members' clients linkify bodies:
 * [{ type: 'text', value }, { type: 'url', value }, ...]. Rendering is left to the caller so
 * nothing is ever injected as HTML.
 */
export const splitLinks = (text) => {
  if (!text) return [];
  const segments = [];
  let last = 0;
  text.replace(URL_PATTERN, (match, offset) => {
    let url = match;
    const trailing = url.match(TRAILING_PUNCTUATION);
    if (trailing) {
      // Keep a closing paren that belongs to the URL itself, e.g. .../Foo_(bar)
      let cut = trailing[0];
      while (cut.startsWith(')') && url.slice(0, url.length - cut.length).includes('(')) {
        cut = cut.slice(1);
      }
      url = url.slice(0, url.length - cut.length);
    }
    if (url.length <= 'https://'.length) return match;
    if (offset > last) segments.push({ type: 'text', value: text.slice(last, offset) });
    segments.push({ type: 'url', value: url });
    last = offset + url.length;
    return match;
  });
  if (last < text.length) segments.push({ type: 'text', value: text.slice(last) });
  return segments;
};
